import { Tooltip } from '@mui/material';
import { FunctionComponent, SVGProps } from 'react';
import l from '../../../lang';
import { ReactComponent as CompletedIcon } from '../../../assets/icons/client-transaction-completed.svg';
import { ReactComponent as PendingIcon } from '../../../assets/icons/client-transaction-pending.svg';
import { ReactComponent as CancelledIcon } from '../../../assets/icons/client-transaction-cancelled.svg';
import { ReactComponent as DeclinedIcon } from '../../../assets/icons/client-transaction-declined.svg';
import { ReactComponent as RefundedIcon } from '../../../assets/icons/client-transaction-refunded.svg';
import './styles.scss';

type StatusIcon = FunctionComponent<SVGProps<SVGSVGElement>>;

const STATUS_ICONS: Record<string, StatusIcon> = {
  COMPLETED: CompletedIcon,
  PENDING: PendingIcon,
  CANCELLED: CancelledIcon,
  DECLINED: DeclinedIcon,
  REFUNDED: RefundedIcon,
  CREATED: PendingIcon,
  EXPIRED: CancelledIcon,
  FAILED: DeclinedIcon,
  review: PendingIcon,
};

const getStatusTranslationKey = (status: string) => {
  if (status === 'review') {
    return 'transactions.status.review';
  }

  return `transactions.status.${status}`;
};

export interface TransactionStatusIconProps {
  status: string;
  tooltipTitle?: string;
  iconClassName?: string;
  wrapClassName?: string;
}

const TransactionStatusIcon = ({
  status,
  tooltipTitle,
  iconClassName = '',
  wrapClassName = '',
}: TransactionStatusIconProps) => {
  const normalizedStatus = status?.toLowerCase() === 'review' ? 'review' : status?.toUpperCase();
  const Icon = STATUS_ICONS[normalizedStatus] ?? PendingIcon;
  const label = tooltipTitle ?? l(getStatusTranslationKey(normalizedStatus));

  return (
    <Tooltip
      title={label}
      arrow
      placement="top"
      classes={{
        tooltip: 'transaction-status-icon__tooltip',
        arrow: 'transaction-status-icon__tooltip__arrow',
      }}
    >
      <span
        className={`transaction-status-icon__wrap ${wrapClassName}`.trim()}
        tabIndex={0}
        aria-label={label}
      >
        <Icon className={`transaction-status-icon ${iconClassName}`.trim()} aria-hidden />
      </span>
    </Tooltip>
  );
};

export default TransactionStatusIcon;
